<template>
  <div>
    <!-- <p class="center"><a class="Button" :href="paymentSiteUrl">Buy</a></p> -->
    <iframe ref="galleryFrame" :src="picassoUrl" v-bind:style="styleObject"></iframe>
  </div>
</template>

<script>
export default {
  name: 'ViewPhotos',
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.handleResize();
      console.log(this.locale);
      window.addEventListener('resize', this.handleResize);
      var body = document.querySelector('body');
      body.style.overflow = 'hidden';
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize);
    var body = document.querySelector('body');
    body.style.overflow = 'auto';
  },
  data () {
    return {
      styleObject: {
        height: '0px',
        width: '0px'
      },
      paymentSiteUrl: process.env.PAYMENT_SITE_URL + '#/bar-code/' + this.$route.params.region
    }
  },
  computed: {
    picassoUrl() {
      const {barcode, region} = this.$route.params;
      if (barcode && region) {
        return `${(process.env.PICASSO_SSL ? 'https' : 'http')}://${region}.${process.env.PICASSO_DOMAIN}/#/${this.locale}/TEST/${barcode}/`
      } else if (barcode) {
        return `${(process.env.PICASSO_SSL ? 'https' : 'http')}://${region}.${process.env.PICASSO_DOMAIN}/${barcode}/`;
      } else if (region === 'ef') {
        return `${process.env.POMVOM_EFTELING_GUEST_APP}/`;
      } else if (region) {
        return `${(process.env.PICASSO_SSL ? 'https' : 'http')}://${region}.${process.env.PICASSO_DOMAIN}/#/${this.locale}/`;
      } else {
        return `${(process.env.PICASSO_SSL ? 'https' : 'http')}://uk.${process.env.PICASSO_DOMAIN}/#/${this.locale}/`;
      }
    }
  },
  methods: {
    handleResize: function() {
      const headerHeight = document.querySelector('.SiteHeader__container').clientHeight;
      const docHeight = document.documentElement.clientHeight;
      var contentHeight = docHeight - headerHeight;
      this.styleObject.height = `${contentHeight}px`;
      this.styleObject.width = `${document.documentElement.clientWidth}px`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
iframe {
  width: 100%;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewPhotos.vue